import { chat } from "@/lib/http";
import type { Account, AccountMember } from "./types";

export function listAccounts() {
  return chat<Account[]>("/v1/chat/accounts");
}

export function createAccount(data: { name: string; plan_id?: string }) {
  return chat<Account>("/v1/chat/accounts", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function getAccount(accountId: string) {
  return chat<Account>(`/v1/chat/accounts/${accountId}`);
}

export function listAccountMembers(accountId: string) {
  return chat<AccountMember[]>(`/v1/chat/accounts/${accountId}/members`);
}
